module.exports = __webpack_public_path__ + "pc/img/body_basic 6.c4dfa789.jpg";